///////////////////////////////////////////////////////////////////////////////////////////////////
//     ____                            __                _
//    / __ \___  ____  ___  ____  ____/ /__  ____  _____(_)__  _____
//   / / / / _ \/ __ \/ _ \/ __ \/ __  / _ \/ __ \/ ___/ / _ \/ ___/
//  / /_/ /  __/ /_/ /  __/ / / / /_/ /  __/ / / / /__/ /  __(__  )
// /_____/\___/ .___/\___/_/ /_/\__,_/\___/_/ /_/\___/_/\___/____/
//           /_/
//
///////////////////////////////////////////////////////////////////////////////////////////////////

import App from '@/App.vue'
import components from '@/components'
import Env from '@/plugins/env'
import filters from '@/utilities/filters'
import Geocoder from './plugins/geocoder'
import i18n from '@/plugins/i18n'
import InfiniteLoading from 'vue-infinite-loading'
import router from '@/plugins/router'
import store from '@/plugins/store'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'
import VueScrollTo from 'vue-scrollto'
import Vuex from 'vuex'

// TODO // Remove dependency on jQuery, Popper, Bootstrap, js-cookie
import 'bootstrap'

///////////////////////////////////////////////////////////////////////////////////////////////////
//    _____ __        __
//   / ___// /___  __/ /__  _____
//   \__ \/ __/ / / / / _ \/ ___/
//  ___/ / /_/ /_/ / /  __(__  )
// /____/\__/\__, /_/\___/____/
//          /____/
//
///////////////////////////////////////////////////////////////////////////////////////////////////

import '@/scss/_index.scss'

///////////////////////////////////////////////////////////////////////////////////////////////////
//     ____  __            _
//    / __ \/ /_  ______ _(_)___  _____
//   / /_/ / / / / / __ `/ / __ \/ ___/
//  / ____/ / /_/ / /_/ / / / / (__  )
// /_/   /_/\__,_/\__, /_/_/ /_/____/
//               /____/
//
///////////////////////////////////////////////////////////////////////////////////////////////////

Vue.use(Env)
Vue.use(Geocoder, { apiKey: 'AIzaSyAEiLRlSgYaaS9tXcHaG1OzGHdOCnZuO6c' })
Vue.use(InfiniteLoading)
Vue.use(VueI18n)
Vue.use(VueRouter)
Vue.use(VueScrollTo)
Vue.use(Vuex)

///////////////////////////////////////////////////////////////////////////////////////////////////
//     _______ ____
//    / ____(_) / /____  __________
//   / /_  / / / __/ _ \/ ___/ ___/
//  / __/ / / / /_/  __/ /  (__  )
// /_/   /_/_/\__/\___/_/  /____/
//
///////////////////////////////////////////////////////////////////////////////////////////////////

Object.keys(filters).forEach(f => Vue.filter(f, filters[f]))

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//    ______                                             __
//   / ____/___  ____ ___  ____  ____  ____  ___  ____  / /______
//  / /   / __ \/ __ `__ \/ __ \/ __ \/ __ \/ _ \/ __ \/ __/ ___/
// / /___/ /_/ / / / / / / /_/ / /_/ / / / /  __/ / / / /_(__  )
// \____/\____/_/ /_/ /_/ .___/\____/_/ /_/\___/_/ /_/\__/____/
//                     /_/
//
///////////////////////////////////////////////////////////////////////////////////////////////////

// import other components
Object.keys(components).forEach(k => Vue.component(k, components[k]))

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//     ____      _ __  _       ___
//    /  _/___  (_) /_(_)___ _/ (_)___  ___
//    / // __ \/ / __/ / __ `/ / /_  / / _ \
//  _/ // / / / / /_/ / /_/ / / / / /_/  __/
// /___/_/ /_/_/\__/_/\__,_/_/_/ /___/\___/
//
///////////////////////////////////////////////////////////////////////////////////////////////////

Vue.config.productionTip = false

export default new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
